import { createSlice } from '@reduxjs/toolkit'

const medicamentosSlice = createSlice({
    name: 'medicamentos',
    initialState: { 
        medicamentos: [],
        medicamentosFiltrados: [],
        // medicamentosImportados: []
    },
    reducers: {
        setMedicamentos(state, action) {
           state.medicamentos = action.payload.filter(medicamento => !medicamento.nombre_medicamento.includes('(IMP)'))
        },
        setMedicamentosFiltrados(state, action) {
            // quita los elementos del arreglo que contengan la palabra IMPORT en el nombre_medicamento
            state.medicamentosFiltrados = action.payload.filter(medicamento => !medicamento.nombre_medicamento.includes('(IMP)'))
        },
    //     setMedicamentosImportados(state, action) {
    //         state.medicamentosImportados = action.payload.filter(medicamento => medicamento.nombre_medicamento.includes('(IMP)'))
    //     }
    }
})

//export const { setMedicamentos, setMedicamentosFiltrados, setMedicamentosImportados} = medicamentosSlice.actions
export const { setMedicamentos, setMedicamentosFiltrados } = medicamentosSlice.actions
export default medicamentosSlice.reducer